import Cookies from 'universal-cookie';
import getBackendHost from 'getBackendHost';
import getFrontendHost from 'getFrontendHost';
import isJson from 'helpers/isJson';

const cookies = new Cookies();

export default function fetchData(data, isCustomer) {

  if (!data) return { status: 'error', statusText: 'Missing payload data' };
  if (!data.url) return { status: 'error', statusText: 'Missing URL' };

  const isUpload = data.upload;
  const token = cookies.get( isCustomer ? 'userId' : 'userId');

  const header = {
    Authorization: token
  };

  if (isUpload && !data.hasFiles) header['Content-Type'] = 'application/json';

  const thisPayload = data.payload;

  if (thisPayload && isUpload && data.extras) Object.entries(data.extras).forEach(function ([key, value]) {
    thisPayload.append(key, value);
  });

  const {
    isFrontend
  } = data;

  let thisUrl = isFrontend ? getFrontendHost() : getBackendHost();
  if (data.url) thisUrl = thisUrl + data.url;

  let thisResponse;
  return fetch(thisUrl, {
    method: isUpload || data.isUpload ? 'POST' : 'GET',
    headers: header,
    mode: 'cors',
    body: isUpload && thisPayload && data.extras ? thisPayload : thisPayload ? JSON.stringify(thisPayload) : ''
  }).then(async (response) => {
    thisResponse = response.clone();
    return response.json().then(responseData => {
      return isJson(responseData) ? JSON.parse(responseData) : responseData;
    });
  }).catch(async (err) => {
    try {
      const stautsText = await thisResponse.text();
      return { status: 'error', error: err, statusText: stautsText ? stautsText : 'Something went wrong... try again.' };
    } catch(e) {
      return { status: 'error', error: err, statusText: 'Something went wrong... try again.' };
    }
  });

}
